var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content g9" },
    [
      _c(
        "Accord",
        { attrs: { title: "Demand" } },
        [
          _c(
            "Accord",
            { attrs: { title: "Enrollment projection" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "demandEnrollment",
                  settings: _vm.enrollmentSettings,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Dispensing schedules" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "demandSchedules",
                  settings: _vm.schedulesSettings,
                  "is-gantt": true,
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "right",
                  on: { click: _vm.onDownloadDemandScheduleClick },
                },
                [_vm._v("Download dispensing schedule in excel")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Consumption" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "demandConsumption",
                  settings: _vm.consumptionSettings,
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "right",
                  on: { click: _vm.onDownloadConsumptionsClick },
                },
                [_vm._v("Download to excel")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }